import React from 'react';
import Input from 'components/input/input.component';
import { IKpu } from 'interfaces/applicant.interface';

interface IProps {
  kpu: IKpu;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const RestConnection: React.FC<IProps> = ({ kpu, handleChange }) => {
  return (
    <>
      <Input name="ip" value={kpu.ip || ''} label={'IP'} onChange={handleChange} />
      <Input name="port" value={kpu.port || ''} label={'Порт'} onChange={handleChange} />
      <Input name="login" value={kpu.login || ''} label={'Логин'} onChange={handleChange} />
      <Input name="pass" value={kpu.pass || ''} label={'Пароль'} onChange={handleChange} />
    </>
  );
};

export default RestConnection;
